/** query keys for the migrated subscription manager */
export const SUBSCRIPTION_MANAGER_QUERY_KEYS = {
  features: (organizationId: string) =>
    ['subscription-manager', 'features', organizationId] as const,
  options: (organizationId: string) => ['subscription-manager', 'options', organizationId] as const,
  subscriptions: (organizationId: string) =>
    ['subscription-manager', 'subscriptions', organizationId] as const,
};

/** maximum number of retry attempts when a query fails */
export const MAX_FAILURES = 3;
